import Nullstack from 'nullstack';
export default function IconBuildingPavilon({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-pavilon",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 21h7v-3a2 2 0 0 1 4 0v3h7"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "21",
    x2: "6",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "18",
    y1: "21",
    x2: "18",
    y2: "12"
  }), "   ", Nullstack.element("path", {
    d: "M6 12h12a3 3 0 0 0 3 -3a9 8 0 0 1 -9 -6a9 8 0 0 1 -9 6a3 3 0 0 0 3 3"
  }), " ");
}